import React from 'react'
import { BBDTag } from '@gravitate-js/excalibrr'

export const StatusRenderer = ({ value }) => {
  return value === 'Success' ? (
    <BBDTag success>{value}</BBDTag>
  ) : value === 'Running' ? (
    <BBDTag theme2>{value}</BBDTag>
  ) : (
    <BBDTag error>{value}</BBDTag>
  )
}
